import styled from "styled-components";
import { MultiOrderItem } from "../../../../types/items";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import useRefillAreaName from "../../../../hooks/useRefillAreaName";
import { useItemInfo } from "../../../../../shared/hooks/item/useItemInfo";
import { FixaListViewItem } from "../../../../../shared/wrappers/FixaListView/FixaListViewItem";
import ItemsListViewItem from "./ItemsListViewItem";
import { getRefillAreaIdFromLocation } from "@fixa/store-locations";

interface ItemListItemWithGroupProps {
  item: MultiOrderItem;
  index: number;
  groupBy: string;
  previousItem: MultiOrderItem | null;
}

const GroupTitleWrapper = styled.div`
  border-top: 8px solid var(--grey100);
`;

const getGroupTitle = (
  item: MultiOrderItem,
  groupBy: string,
  refillAreaName: string,
  itemName: string
): string => {
  switch (groupBy) {
    case "hfb":
      return refillAreaName;
    case "slid":
      return item.refillLocation;
    case "article":
      return `${itemName} • ${formatProductIdWithDots(item.articleNumber)}`;
    default:
      return "";
  }
};

export const ItemsListViewItemWithGroup = ({
  item,
  index,
  groupBy,
  previousItem,
}: ItemListItemWithGroupProps) => {
  const refillAreaId = getRefillAreaIdFromLocation(
    item.home_location || item.pickupLocation,
    {
      enableSFM: true,
    }
  );
  const refillAreaName = useRefillAreaName(refillAreaId);
  const { data: itemData } = useItemInfo(item.articleNumber);
  const itemName = itemData?.name ?? "";

  const prevRefillAreaId = getRefillAreaIdFromLocation(
    previousItem?.home_location || previousItem?.pickupLocation || "",
    { enableSFM: true }
  );
  const prevRefillAreaName = useRefillAreaName(prevRefillAreaId);
  const prevItemInfo = useItemInfo(previousItem?.articleNumber ?? "");
  const prevItemName = prevItemInfo.data?.name ?? "";

  const currentGroupTitle = getGroupTitle(
    item,
    groupBy,
    refillAreaName,
    itemName
  );
  const previousGroupTitle = previousItem
    ? getGroupTitle(previousItem, groupBy, prevRefillAreaName, prevItemName)
    : null;

  const showTitle = groupBy && currentGroupTitle !== previousGroupTitle;

  return (
    <>
      {showTitle && (
        <GroupTitleWrapper>
          <FixaListViewItem
            id={`group-${currentGroupTitle}`}
            title={currentGroupTitle}
            emphasised
            inset
          />
        </GroupTitleWrapper>
      )}
      <ItemsListViewItem item={item} index={index} />
    </>
  );
};
